import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { PutterHeadModelForSaveDto } from '../../api/models';

export type TABLE_TYPE = Table<PutterHeadModelForSaveDto>;

export const TABLE = 'putterHeadModel';
const SCHEMA = 'headModelId, sortId';

class PutterHeadModelDatabase implements DataRepository<PutterHeadModelForSaveDto> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<PutterHeadModelForSaveDto | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: PutterHeadModelForSaveDto, key: Key): Promise<PutterHeadModelForSaveDto> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: PutterHeadModelForSaveDto[]): Promise<PutterHeadModelForSaveDto[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<PutterHeadModelForSaveDto[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const PutterHeadModelDB = new PutterHeadModelDatabase(db);
